'use strict';

import { assignDeep, Buildings, threeJsVariables } from '../../settings';
import { setTilesColor, setTilesEmissive } from './environment';
import { sceneObjectsGroup } from '../points/points';
import { Terrain } from '../components/Terrain/Terrain';
import { OSMEnv } from './sceneBackground';
import { LinearSRGBColorSpace } from 'three';

export class ColorCorrection {
    constructor () {
        const DEFAULT_SETTINGS = {
            tiles: {
                color: '#ffffff',
                emissive: '#000000'
            },
            buildings: {
                color: '#ffffff',
                emissive: '#000000'
            },
            osm: {
                color: '#dedede',
                emissive: '#000000'
            },
            ground: {
                color: '#ffffff',
                emissive: '#000000'
            }
        };

        this.settings = assignDeep(DEFAULT_SETTINGS,config.threejs.colorCorrection || {});
    }

    debug() {
        const functions = {
            export: () => this.export()
        };
        const gui = threeJsVariables.gui;
        const mainFolder = gui.addFolder('Color correction');
        Object.entries(this.settings).forEach(([model,colors]) => {
            const modelFolder = mainFolder.addFolder(model);
            Object.keys(colors).forEach(key => {
                modelFolder.addColor(this.settings[model],key).onChange((newColor) => ColorCorrection.update(model,key,newColor));
            });
        });

        mainFolder.add(functions,'export');
    }

    export() {
        const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(this.settings));
        const href = document.createElement('a');
        href.setAttribute('href',dataStr);
        href.setAttribute('download',`${config.projectTitle}_color-correction.json`);
        href.click();
    }

    getColors(type) {
        return this.settings[type];
    }

    static update(model, colorKey, color){
       if (threeJsVariables.bundleConfig?.version) return;

       switch (model) {
           case 'tiles':
               if (colorKey === 'color') {
                   setTilesColor(color);
               } else {
                   setTilesEmissive(color);
               }
               break;
           case 'buildings':
               const buildings = Buildings.getBuildingsArray();
               buildings.forEach(building => {
                  building.colors[colorKey] = color;
                  building.applyColorCorrection();
               });
               sceneObjectsGroup.traverse(el => {
                   if (el.isMesh) {
                        el.material[colorKey].setStyle(color,LinearSRGBColorSpace);
                   }
               });
               break;
           case 'osm':
               OSMEnv.buildingsMaterials.forEach(material => material[colorKey].set(color));
               break;
           case 'ground':
               Terrain.applyColorCorrection(colorKey,color);
               break;

       }
    }

}
